import { useEffect, useState } from 'react';
import NotificationsIcon from './images/notification.svg';
import Notification from './NotificationPopup';
import NotificationModal from './NotificationModal';
import { useMutation, useQuery } from '@tanstack/react-query';
import './Notifications.css';
import { useNotificationSocket } from './NotificationSocket';
import { useMediaQuery } from '@mui/material';

const apiUrl = process.env.REACT_APP_BACKEND_API;

const fetchNotifications = async (notificationsFetchCalls, token) => {
  const response = await fetch(
    `${apiUrl}/notifications?page=${notificationsFetchCalls}&limit=5`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.json();
};

export default function Notifications() {
  const [notification, setNotification] = useState(null);
  const [showNotification, setShowNotification] = useState(false);
  const isMobile = useMediaQuery('(max-width:600px)');
  const token = localStorage.getItem('token');
  const socket = useNotificationSocket(token);

  const [showNotificationsModal, setShowNotificationsModal] = useState(false);
  const [notificationsFetchCalls, setNotificationsFetchCalls] = useState(1);

  const { mutate: readNotifications } = useMutation({
    mutationFn: () =>
      fetch(`${apiUrl}/notifications/read`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }).then((res) => res.json()),

    onSuccess: (response) => {
      refetch();
    },
    onError: (error) => {},
  });

  const { data, refetch, isFetching } = useQuery(
    ['notifications', notificationsFetchCalls],
    () => fetchNotifications(notificationsFetchCalls, token),

    {
      enabled: false,
      onSuccess: (response) => {},
      onError: (error) => {},
    }
  );

  useEffect(() => {
    if (!socket) return;
    socket.on('connect', () => {});

    socket.on('notification', (notification) => {
      setNotification(notification);
      setShowNotification(true);
      refetch();
    });

    return () => {
      socket.disconnect();
    };
  }, [socket]);

  useEffect(() => {
    refetch();
  }, [notificationsFetchCalls]);

  return (
    <>
      <div
        className="notifications-button"
        style={{ top: isMobile ? '130px' : '90px' }}
        onClick={() =>
          setShowNotificationsModal((prevState) => {
            if (prevState === true) {
              setNotificationsFetchCalls(1);
              readNotifications();
            }
            return !prevState;
          })
        }
      >
        <img height={18} src={NotificationsIcon} alt="" />

        {data?.data?.unreadCount > 0 && (
          <div className="notifications-number">{data.data.unreadCount}</div>
        )}
      </div>

      {showNotificationsModal && (
        <div
          className="notifications-modal notifications-animation"
          style={{ top: isMobile ? '135px' : '95px' }}
        >
          <div className="notifications-modal-arrow"></div>

          <div>
            <NotificationModal
              notifications={data?.data?.notifications}
              setNotificationsFetchCalls={setNotificationsFetchCalls}
              refreshNotifications={refetch}
              isFetching={isFetching}
              totalPages={data?.pagination?.totalPages}
              page={data?.pagination?.page}
              total={data?.pagination?.total}
            />
          </div>
        </div>
      )}

      {showNotification && (
        <Notification
          notification={notification}
          onClose={() => setShowNotification(false)}
        />
      )}
    </>
  );
}
